import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import saleService from "../../../Services/saleService";
import InvocieModalbyServices from "../../../Components/InvocieModalbyServices";

const ServicesSales = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [groupedData, setGroupedData] = useState({});
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const getSales = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllServicesSale();

        const sales = response.sales || [];

        const grouped = sales.reduce((acc, item) => {
          if (!acc[item.invoice]) acc[item.invoice] = [];
          acc[item.invoice].push(item);
          return acc;
        }, {});

        setGroupedData(grouped);
        setLoading(false);
      } catch {
        setLoading(false);
        toast.error("Error fetching Sales");
      }
    };

    getSales();
  }, []);

  useEffect(() => {
    const filteredResult = Object.entries(groupedData)
      .filter(([invoice, items]) =>
        items.some((item) =>
          item?.patient_name
            ?.toLowerCase()
            .includes(searchData.toLowerCase())
        )
      )
      .map(([invoice, items]) => ({ invoice, items }));

    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, groupedData]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className="p-3 sm:p-6">

     <div className="bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-4 sm:mb-5 shadow-sm">

  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">

    <div>
      <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800">
        Services Sales Record
      </h1>

      <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
        {filteredData?.length || 0} records found
      </p>
    </div>

    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 w-full sm:w-auto">

      <input
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        className="w-full sm:w-auto text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px]"
      />

      <input
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        className="w-full sm:w-auto text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px]"
      />

      {(startDate || endDate) && (
        <button
          onClick={() => {
            setStartDate("");
            setEndDate("");
          }}
          className="w-full sm:w-auto text-[13px] bg-gray-100 hover:bg-gray-200 px-3 py-[7px] rounded-lg"
        >
          Clear
        </button>
      )}

      <div className="relative w-full sm:w-[200px]">
        <SearchIcon
          className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
          style={{ fontSize: 16 }}
        />

        <input
          type="search"
          placeholder="Search patient..."
          value={searchData}
          onChange={(e) => setSearchData(e.target.value)}
          className="pl-8 pr-3 py-[7px] w-full text-[13px] bg-gray-50 border border-gray-200 rounded-lg"
        />
      </div>

    </div>
  </div>
</div>
      <div className="hidden sm:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <div className="overflow-x-auto">

          <table className="w-full min-w-[600px]">

            <thead>
              <tr className="bg-[#2F6DB4] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">Invoice</th>
                <th className="py-3 px-4 text-center">Date</th>
                <th className="py-3 px-4 text-center">Time</th>
                <th className="py-3 px-4 text-left">Patient</th>
                <th className="py-3 px-4 text-center">Items</th>
                <th className="py-3 px-4 text-center">Amount</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>

            <tbody>

              {loading ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400 text-[13px]">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400 text-[13px]">
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData.map(({ invoice, items }) => (
                  <tr key={invoice} className="border-t hover:bg-gray-50 text-[13px]">

                    <td className="py-3 px-4 text-gray-500">
                      {invoice}
                    </td>

                    <td className="py-3 px-4 text-center text-gray-600">
                      {formatDate(items[0]?.sale_date)}
                    </td>

                    <td className="py-3 px-4 text-center text-gray-600">
                      {new Date(items[0]?.sale_date).toLocaleTimeString()}
                    </td>

                    <td className="py-3 px-4 font-[500] text-gray-800">
                      {items[0]?.patient_name}
                    </td>

                    <td className="py-3 px-4 text-center text-gray-600">
                      {items.length}
                    </td>

                    <td className="py-3 px-4 text-center font-[500] text-gray-800">
                      {items.reduce(
                        (acc, item) => acc + item.quantity * item.unit_price,
                        0
                      )}
                    </td>

                    <td className="py-3 px-4 text-center">

                      <button
                        onClick={() =>
                          setSelectedInvoice({
                            invoiceNumber: items[0]?.invoice,
                            patientName: items[0]?.patient_name,
                            doctorName: items[0]?.doctor_name,
                            patientAddress: items[0]?.patient_address,
                            sale_date: items[0]?.sale_date,
                            invoiceData: items,
                          })
                        }
                        className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100"
                      >
                        View Invoice
                      </button>

                    </td>

                  </tr>
                ))
              )}

            </tbody>

          </table>
        </div>
      </div>

      <div className="sm:hidden space-y-2.5">

        {paginatedData.map(({ invoice, items }) => (

          <div
            key={invoice}
            className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
          >

            <div className="flex justify-between items-start mb-3">

              <div>
                <span className="text-[10px] font-bold text-[#2F6DB4]">
                  Invoice #{invoice}
                </span>

                <p className="text-[14px] font-[600] text-gray-800">
                  {items[0]?.patient_name}
                </p>
              </div>

              <button
                onClick={() =>
                  setSelectedInvoice({
                    invoiceNumber: items[0]?.invoice,
                    patientName: items[0]?.patient_name,
                    doctorName: items[0]?.doctor_name,
                    patientAddress: items[0]?.patient_address,
                    sale_date: items[0]?.sale_date,
                    invoiceData: items,
                  })
                }
                className="bg-blue-50 text-blue-600 text-[11px] px-2.5 py-1 rounded-md"
              >
                Invoice
              </button>

            </div>

            <div className="grid grid-cols-3 gap-2">

              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-[10px] text-gray-400">Date</p>
                <p className="text-[13px] font-[600]">
                  {formatDate(items[0]?.sale_date)}
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-[10px] text-gray-400">Items</p>
                <p className="text-[13px] font-[600]">
                  {items.length}
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-[10px] text-gray-400">Amount</p>
                <p className="text-[13px] font-[600]">
                  {items.reduce(
                    (acc, item) => acc + item.quantity * item.unit_price,
                    0
                  )}
                </p>
              </div>

            </div>

          </div>

        ))}

      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      {selectedInvoice && (
        <InvocieModalbyServices
          invoiceNumber={selectedInvoice.invoiceNumber}
          patientName={selectedInvoice.patientName}
          doctorName={selectedInvoice.doctorName}
          patientAddress={selectedInvoice.patientAddress}
          sale_date={selectedInvoice.sale_date}
          invoiceData={selectedInvoice.invoiceData}
          onClose={() => setSelectedInvoice(null)}
        />
      )}
    </div>
  );
};

export default ServicesSales;